import {
  useCreateCentralLabMutation,
  useDeleteCentralLabMutation,
  useGetCentralLabDetailsMutation,
  useUpdateCentralLabMutation,
} from "../store/services/centralLabQuery";

export const useCentralLab = () => {
  const [
    createCentralLab,
    {
      data: createCentralLabData,
      isLoading: createCentralLabIsLoading,
      isError: createCentralLabIsError,
      error: createCentralLabError,
      isSuccess: createCentralLabIsSuccess,
    },
  ] = useCreateCentralLabMutation();

  const [
    updateCentralLab,
    {
      data: updateCentralLabData,
      isLoading: updateCentralLabIsLoading,
      isError: updateCentralLabIsError,
      error: updateCentralLabError,
      isSuccess: updateCentralLabIsSuccess,
    },
  ] = useUpdateCentralLabMutation();
  const [
    deleteCentralLab,
    {
      data: deleteCentralLabData,
      isLoading: deleteCentralLabIsLoading,
      isError: deleteCentralLabIsError,
      error: deleteCentralLabError,
      isSuccess: deleteCentralLabIsSuccess,
    },
  ] = useDeleteCentralLabMutation();
  const [
    getCentralLabDetails,
    {
      data: centralLabDetailsData,
      isLoading: centralLabDetailsIsLoading,
      isError: centralLabDetailsIsError,
      error: centralLabDetailsError,
      isSuccess: centralLabDetailsIsSuccess,
    },
  ] = useGetCentralLabDetailsMutation();

  return {
    createCentralLab,
    createCentralLabData,
    createCentralLabIsLoading,
    createCentralLabIsError,
    createCentralLabError,
    createCentralLabIsSuccess,
    updateCentralLab,
    updateCentralLabData,
    updateCentralLabIsLoading,
    updateCentralLabIsError,
    updateCentralLabError,
    updateCentralLabIsSuccess,
    deleteCentralLab,
    deleteCentralLabData,
    deleteCentralLabIsLoading,
    deleteCentralLabIsError,
    deleteCentralLabError,
    deleteCentralLabIsSuccess,
    getCentralLabDetails,
    centralLabDetailsData,
    centralLabDetailsIsLoading,
    centralLabDetailsIsError,
    centralLabDetailsError,
    centralLabDetailsIsSuccess,
  };
};
